import React, {useCallback, useEffect, useState} from "react";
import { Card, Form } from 'react-bootstrap';
import PlotThumb from './PlotThumb';
import { getVar, buildMarketFilters, SmallTitle } from './Helper';
import axios from 'axios';      
import styled from 'styled-components';


const SearchWrap = styled.div`
    margin-top:15px;
`;

const SidebarTrigger = styled.button`
    width: 40px;    
    display: inline-block;  
    position: absolute;
    height: 37px;
    border: 1px solid #c5c5c5;
    border-radius: 4px;
`;


const FilterBtnText = styled.span`
    display: block;
    margin-top: 10px;
`

const FilterBtn = styled.div`    
    min-height: 115px;
    padding-top: 15px;
    padding-bottom:15px;
    border-radius:4px;
    margin-bottom:0;
    font-size:10px;
    line-height: 12px;
    text-align: center;   
    padding-right:5px;
    padding-left: 5px;
    background-color: ${props => props.active === true ? '#ebebeb' : '#fff'}; 
    box-shadow: ${props => props.active === true ? 'inset 0px 0px 3px #30b87b' : 'none'}; 
    :hover{
        cursor: pointer;
        background:#ebebeb;
    }
`

const FloatingSidebar = React.memo(({activeMarkets, filterMarkets, searchPlots, setLeftSidebar}) => { 
    
    let [featured,setFeatured] = useState([]);
    let [markets,setMarkets] = useState([]);

    useEffect(()=>{      
        axios.get(getVar().apiUrl+'get-plots/').then(response => {            
            let data = response.data.filter((item)=>{
                return item.featured === 1; 
            })
            setFeatured(data);   
        }) 
        setMarkets(buildMarketFilters());      
    },[])

    const FilterHandler = useCallback((key)=>{
        filterMarkets(key);
        setMarkets(buildMarketFilters());           
    },[filterMarkets])

    const SearchHandler = useCallback((evt)=>{
        searchPlots(evt);
        setMarkets(buildMarketFilters());   
    },[searchPlots])

    return (
        <div className="floating-sidebar">  
        <SearchWrap>
        <SidebarTrigger  
            onClick={(e)=>{
                setLeftSidebar(true); 
                e.preventDefault();
            }}>
                <svg viewBox="0 0 100 100" width="20" height="20" fill="#909090">
                    <rect width="100" height="20"></rect>
                    <rect y="30" width="100" height="20"></rect>
                    <rect y="60" width="100" height="20"></rect>
                </svg>
            </SidebarTrigger>
        <Form.Group>           
            <Form.Control style={{ marginLeft : '50px', width:'232px'}} type="text" placeholder="Search" onKeyDown={(evt)=>{SearchHandler(evt)}} />         
        </Form.Group> 
        </SearchWrap>

        <Card className="l-widget featured-products">
            <SmallTitle>Featured Products</SmallTitle>
            {featured.map((item)=>{
                return (
                    <PlotThumb key={item.id} item={item} />      
                )
            })}
        </Card>

        <Card className="l-widget by-market">
            <SmallTitle>Filter by Market</SmallTitle>
            <div className="row" style={{marginLeft:'0px',marginRight:'0px',marginTop:'5px'}}>
            {markets.map((item)=>{                 
                return ( 
                    <span key={item.key}  style={{paddingLeft:'5px',paddingRight:'5px'}}    className="col-4"  >
                    <FilterBtn  
                        active={ activeMarkets.includes(item.key) ? true : false}  
                        onClick={()=>{                                                   
                            FilterHandler(item.key)
                        }}>
                        <img src={item.imgUrl} alt={item.name}  />
                        <FilterBtnText>{item.name}</FilterBtnText>
                    </FilterBtn>
                    </span>
               )
            })}
            </div>
        </Card>
        </div>
    )
}); 

export default FloatingSidebar;